
import Vue from 'vue'
import App from './App.vue'

import router from './router'
import VeeValidate from 'vee-validate'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'


import CurrentOffsetDateComponent from '@/components/CurrentOffsetDate'
import GaugeComponent from '@/components/Gauge'
import FormDialogComponent from '@/components/FormDialog'
import AppSideBarComponent from '@/components/AppSideBar'
import InProgressComponent from '@/components/InProgress'
import LedComponent from '@/components/Led'
import SwitchComponent from '@/components/Switch'
import DeviceComponent from '@/components/route-components/content-components/Device'
import RegisterDeviceComponent from '@/components/route-components/content-components/RegisterDevice'
import RegisterApiKeyComponent from '@/components/route-components/content-components/RegisterApiKey'
import RegisterDeviceProfileComponent from '@/components/route-components/content-components/RegisterDeviceProfile'
import LoraHowTo from '@/components/route-components/content-components/HowToLoRa'
import SigfoxHowTo from '@/components/route-components/content-components/HowToSigfoxNew'
import LteHowTo from '@/components/route-components/content-components/HowToLte'

// import AppConfig from '@/builtConf.json'
import store from '@/store/store'
import AuthenticationFactory from '@/modules/authentication/AuthenticationFactory' 
import DeviceManagerFactory from '@/modules/deviceManager/DeviceManagerFactory' 
import NetworkRequestGeneratorFactory from '@/modules/network/NetworkRequestGeneratorFactory' 

import axios from 'axios'
// import { AppInsightsAnalytics, AppInsightsConfiguration } from 'etna-client-analytics';
import { Analytics } from './modules/analytics/Analytics'

let configUrl = "assets/builtConf.json"
axios.request({
  method: "get",
  url: configUrl
}).then(
(data) =>{

  let AppConfig = data.data

  Vue.config.productionTip = false

  Vue.use(VeeValidate)
  Vue.use(Vuetify, {
      options: {
        cspNonce: 'dQw4w9WgXcQ'
      }
    }
  )

  Vue.component('current-offset-date-component',CurrentOffsetDateComponent)
  Vue.component('gauge',GaugeComponent)
  Vue.component('formdialog',FormDialogComponent)
  Vue.component('inprogress',InProgressComponent)
  Vue.component('appsidebar',AppSideBarComponent)
  Vue.component('led',LedComponent)
  Vue.component('custom-switch',SwitchComponent)
  Vue.component('device',DeviceComponent)
  Vue.component('register-device',RegisterDeviceComponent)
  Vue.component('register-apikey',RegisterApiKeyComponent)
  Vue.component('register-deviceprofile',RegisterDeviceProfileComponent)
  Vue.component('lora-how-to',LoraHowTo)
  Vue.component('sigfox-how-to',SigfoxHowTo)
  Vue.component('lte-how-to',LteHowTo)

  AppConfig.install = function(){
    Object.defineProperty(Vue.prototype, 'appConfig', {
      get () { return AppConfig }
    })
  }
  Vue.use(AppConfig)

  let settings = {}
  //Object.assign(settings,AppConfig.api[AppConfig.provider],{authentication:AppConfig.authentication[AppConfig.provider]},AppConfig.models[AppConfig.provider])
  Object.assign(settings,{env: AppConfig.env},AppConfig.backendApi,AppConfig.models)

  let modules = {}
  modules.authentication = AuthenticationFactory.create(AppConfig.provider,modules,settings)
  modules.deviceManager = DeviceManagerFactory.create(AppConfig.provider,modules,settings)
  modules.networkRequestGenerator = NetworkRequestGeneratorFactory.create(AppConfig.provider,modules,settings)
  modules.analytics = new Analytics(AppConfig.backendApi.analytics.connectionString)
  modules.install = function(){
    Object.defineProperty(Vue.prototype, 'modules', {
      get () { return modules }
    })
  }

  // const config = new AppInsightsConfiguration("",AppConfig.backendApi.analytics.connectionString);
  // AppInsightsAnalytics.setEnabled("");
  // AppInsightsAnalytics.setup(config);

  // router.beforeEach((to, from, next) => {

  //   if (to.matched.some(record => record.meta.requiresAuth)) {
  //     if (!store.getters["authentication/isLoggedIn"]) {
  //       next({ name: AppConfig.appNavigation.navigationBar.unlogged.default.routeName })
  //     } else {
  //         next()
  //     }
  //   } else {
  //     if((to.name=='login'||to.name=='singup')&&store.getters["authentication/isLoggedIn"]==true)
  //       next({ name: AppConfig.views.sidebar.logged.default.routeName })
  //     else
  //       next()
  //   }
  // })


  store.commit('setServiceModule',modules)
  // store.commit('devices/setMetadata',AppConfig.models[AppConfig.provider].data.device)
  //store.commit('setMetadata',settings)
  store.commit('setMetadata',AppConfig)
  store.commit('setAppRouter',router)

  new Vue({
    render: h => h(App),  
    router,
    store: store,
  }).$mount('#app')




  Object.defineProperty(Object.prototype, "getCaseInsensProp", {
    value: function (prop) {
        var key,self = this
        for (key in self) {
            if (key.toLowerCase() == prop.toLowerCase()) {
                return self[key]
            }
        }
    },
    enumerable: false
  })

  Object.defineProperty(Object.prototype, "setCaseInsensProp", {
    value: function (prop, val) {
        var key,self = this
        var found = false
        if (Object.keys(self).length > 0) {
            for (key in self) {
                if (key.toLowerCase() == prop.toLowerCase()) {
                    found = true                      
                    self[key] = val
                    break
                }
            }
        }
        if (!found) {
            self[prop] = val
        }
        return val
    },
    enumerable: false
  })

  Object.defineProperty(Object.prototype, "mergeDeep", {
    value:function(...sources) {
      let target = this;
      function isObject(item) {
        return (item && typeof item === 'object' && !Array.isArray(item));
      }

      if (!sources.length) return target;
      const source = sources.shift();
    
      if (isObject(target) && isObject(source)) {
        for (const key in source) {
          if (isObject(source[key])) {
            if (!target[key]) Object.assign(target, { [key]: {} });
            target[key].mergeDeep(source[key]);
          } else {
            Object.assign(target, { [key]: source[key] });
          }
        }
      }
    
      return target.mergeDeep(...sources);
    },
    enumerable: false
  })

})